import { getHexagonSizes } from './hexagon/get-hexagon-sizes.js';
import { getSquaredSizes } from './square/get-squared-sizes.js';
import { HoneycombTileShape } from '../../types/honeycomb.js';

export interface ShapeSizes {
  height: number;
  halfHeight: number;
  halfWidth: number;
}

const ShapeBasedSizes = {
  circle: getSquaredSizes,
  hexagon: getHexagonSizes,
  square: getSquaredSizes,
};

export const getSizesAbstract = (
  shape: HoneycombTileShape,
  width: number,
): ShapeSizes => {
  return ShapeBasedSizes[shape](width);
};
